module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售通话记录AI")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "录音日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.defaultDate,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择日期"
    },
    on: {
      "on-change": _vm.onDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听记标题",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.fileName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fileName", $$v)
      },
      expression: "queryParam.fileName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定人"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.adminUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminUserId", $$v)
      },
      expression: "queryParam.adminUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/crm/dviAudio/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.detailTitle,
      "width": "960",
      "mask-closable": false,
      "class-name": "dvi-audio-detail-modal"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [(_vm.detailLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "color": "#808695"
    }
  }, [_vm._v("加载中…")])], 1) : (_vm.detail) ? _c('div', {
    staticClass: "dvi-detail"
  }, [_c('div', {
    staticClass: "dvi-detail-head"
  }, [_c('div', {
    staticClass: "dvi-detail-title",
    attrs: {
      "title": _vm.displayTitle(_vm.detail.fileName)
    }
  }, [_vm._v(_vm._s(_vm.displayTitle(_vm.detail.fileName)))]), _vm._v(" "), _c('div', {
    staticClass: "dvi-detail-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.detail.createTime || '—'))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDuration(_vm.detail.durationMs)))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.adminUserName || '—'))]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), (_vm.detail.uid) ? _c('span', [_vm._v("学生 · " + _vm._s(_vm.studentLabel(_vm.detail))), (_vm.detail.studentMobile) ? [_vm._v(" · " + _vm._s(_vm.detail.studentMobile))] : _vm._e()], 2) : _c('span', [_vm._v("学生 · 未绑定 "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openBind(_vm.detail)
      }
    }
  }, [_vm._v("绑定学生")])]), _vm._v(" "), _c('Tag', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "color": _vm.detail.hasSummary ? 'green' : 'default'
    }
  }, [_vm._v("摘要" + _vm._s(_vm.detail.hasSummary ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasAsrClean ? 'green' : 'default'
    }
  }, [_vm._v("清洗" + _vm._s(_vm.detail.hasAsrClean ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasTranscript ? 'blue' : 'default'
    }
  }, [_vm._v("原文" + _vm._s(_vm.detail.hasTranscript ? '有' : '无'))]), _vm._v(" "), _c('Tag', {
    attrs: {
      "color": _vm.detail.hasAudio ? 'blue' : 'default'
    }
  }, [_vm._v("音频" + _vm._s(_vm.detail.hasAudio ? '有' : '无'))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [(_vm.detail.storageUrl) ? _c('audio', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.detail.storageUrl,
      "controls": ""
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无音频（尚未转存到七牛）")])]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("摘要")]), _vm._v(" "), (_vm.detail.summaryContent) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.summaryHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无摘要")])]), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-head"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("AI清洗")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "ghost": "",
      "loading": _vm.aiCleanLoading,
      "disabled": _vm.aiCleanLoading || !_vm.canAiClean
    },
    on: {
      "click": _vm.handleAiClean
    }
  }, [_vm._v(_vm._s(_vm.aiCleanBtnText))])], 1), _vm._v(" "), (_vm.detail.asrCleanContent) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.cleanHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无 AI 清洗内容")])]), _vm._v(" "), (_vm.hasTodos || _vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("待办")]), _vm._v(" "), (_vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-empty",
    staticStyle: {
      "color": "#ed4014"
    }
  }, [_vm._v(_vm._s(_vm.detail.todoError))]) : _vm._e(), _vm._v(" "), (_vm.hasTodos) ? _c('ul', {
    staticClass: "dvi-todo-list"
  }, _vm._l((_vm.detail.todos), function(t, idx) {
    return _c('li', {
      key: idx
    }, [_c('span', {
      staticClass: "todo-box"
    }, [_vm._v("☐")]), _vm._v(_vm._s(t))])
  }), 0) : (!_vm.detail.todoError) ? _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无待办")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dvi-section"
  }, [_c('div', {
    staticClass: "dvi-section-head"
  }, [_c('div', {
    staticClass: "dvi-section-title"
  }, [_vm._v("原始对话")]), _vm._v(" "), (_vm.chatBubbles.length) ? _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleRoleSwap
    }
  }, [_vm._v("转换角色")]) : _vm._e()], 1), _vm._v(" "), (_vm.chatBubbles.length) ? _c('div', {
    staticClass: "dvi-chat"
  }, _vm._l((_vm.chatBubbles), function(b, idx) {
    return _c('div', {
      key: idx,
      staticClass: "dvi-bubble-row",
      class: b.side
    }, [_c('div', {
      staticClass: "dvi-bubble"
    }, [_c('div', {
      staticClass: "dvi-bubble-meta"
    }, [_c('span', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(b.nick))]), _vm._v(" "), (b.timeLabel) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(b.timeLabel))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dvi-bubble-text"
    }, [_vm._v(_vm._s(b.text))])])])
  }), 0) : (_vm.fallbackTranscript) ? _c('pre', {
    staticClass: "dvi-raw"
  }, [_vm._v(_vm._s(_vm.fallbackTranscript))]) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无原始对话")])]), _vm._v(" "), _c('Collapse', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "simple": ""
    }
  }, [_c('Panel', {
    attrs: {
      "name": "meta"
    }
  }, [_vm._v("元信息\n          "), _c('div', {
    staticClass: "dvi-meta-extra",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_vm._v("ID：" + _vm._s(_vm.detail.id))]), _vm._v(" "), _c('div', [_vm._v("SN：" + _vm._s(_vm.detail.sn || '—'))]), _vm._v(" "), _c('div', [_vm._v("fileId：" + _vm._s(_vm.detail.fileId || '—'))]), _vm._v(" "), _c('div', [_vm._v("minutesId：" + _vm._s(_vm.detail.minutesId || '—'))])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "绑定学生",
      "width": "480",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.closeBind
    },
    model: {
      value: (_vm.bindVisible),
      callback: function($$v) {
        _vm.bindVisible = $$v
      },
      expression: "bindVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入6位学生ID",
      "clearable": "",
      "disabled": _vm.bindResolving
    },
    on: {
      "on-blur": _vm.resolveStudent,
      "on-enter": _vm.resolveStudent
    },
    model: {
      value: (_vm.bindForm.uidInput),
      callback: function($$v) {
        _vm.$set(_vm.bindForm, "uidInput", $$v)
      },
      expression: "bindForm.uidInput"
    }
  }), _vm._v(" "), (_vm.bindResolving) ? _c('Spin', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bindForm.studentName || '—'))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bindForm.studentMobile || '—'))])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeBind
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.bindForm.resolvedUid,
      "loading": _vm.bindSaving
    },
    on: {
      "click": _vm.saveBind
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.previewTitle,
      "width": "760",
      "mask-closable": false,
      "class-name": "dvi-audio-preview-modal"
    },
    on: {
      "on-cancel": _vm.closePreview
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [(_vm.previewLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "40px 0"
    }
  }, [_c('Spin', {
    attrs: {
      "size": "large"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "color": "#808695"
    }
  }, [_vm._v("加载中…")])], 1) : (_vm.previewDetail) ? _c('div', {
    staticClass: "dvi-preview-body"
  }, [(_vm.previewKind === 'summary') ? [(_vm.previewSummaryHtml) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.previewSummaryHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无摘要")])] : (_vm.previewKind === 'clean') ? [(_vm.previewCleanHtml) ? _c('div', {
    staticClass: "dvi-md track-md",
    domProps: {
      "innerHTML": _vm._s(_vm.previewCleanHtml)
    }
  }) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无 AI 清洗内容")])] : (_vm.previewKind === 'transcript') ? [_c('div', {
    staticClass: "dvi-section-head",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('div', {
    staticClass: "dvi-section-title",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("原始对话")]), _vm._v(" "), (_vm.previewChatBubbles.length) ? _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.togglePreviewRoleSwap
    }
  }, [_vm._v("转换角色")]) : _vm._e()], 1), _vm._v(" "), (_vm.previewChatBubbles.length) ? _c('div', {
    staticClass: "dvi-chat dvi-chat-preview"
  }, _vm._l((_vm.previewChatBubbles), function(b, idx) {
    return _c('div', {
      key: 'p' + idx,
      staticClass: "dvi-bubble-row",
      class: b.side
    }, [_c('div', {
      staticClass: "dvi-bubble"
    }, [_c('div', {
      staticClass: "dvi-bubble-meta"
    }, [_c('span', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(b.nick))]), _vm._v(" "), (b.timeLabel) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(b.timeLabel))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dvi-bubble-text"
    }, [_vm._v(_vm._s(b.text))])])])
  }), 0) : (_vm.previewFallbackTranscript) ? _c('pre', {
    staticClass: "dvi-raw"
  }, [_vm._v(_vm._s(_vm.previewFallbackTranscript))]) : _c('div', {
    staticClass: "dvi-empty"
  }, [_vm._v("暂无原始对话")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closePreview
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2d97d1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/DviAudioList.vue
// module id = 1716
// module chunks = 8